import { JournalPreviewCard } from "./JournalPreviewCard";
export default JournalPreviewCard;
